<template>
    <div>
        <keyboard-events v-on:keyup="keyboardEvent"></keyboard-events>
        <div class="row">
            <div class="col-md-3">
                <filtrosreporterutas-component ref="filtersReport"></filtrosreporterutas-component>
            </div>
            <div class="col-md-9">
                <div class="row">
                    <div class="col-md-4 text-center"></div>
                    <div class="col-md-4 text-center">
                        <button class="btn ripple btn-primary" @click="getReportEncuestas">Generar Reporte </button>
                    </div>
                    <div class="col-md-4" v-if="showResultEncuestas">
                        <div v-if="loadfileEncuestas">
                            <img :src="'/theme/img/loads/loadfile.gif'" alt="carga archivo" height="40">
                            <p>Preparando archivo, espere...</p>
                        </div>
                        <button v-if="!loadfileEncuestas"  class="btn btn-success" type="button" @click="ExportFileEncuestas"><i class="fas fa-file-excel"></i> <i class="fe fe-download-cloud"></i><b> Descargar Excel</b></button>
                    </div>
                </div><br>
                <div class="row">
                    <div class="col-md-12" v-show="showResultEncuestas">
                        <v-client-table :data="tableDataEncuestas" :columns="columnsEncuestas" :options="optionsEncuestas" class="table-responsive" ref="tablePromociones">
                        </v-client-table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "tablaEncuestas",
    data(){
        return{
            loadfileEncuestas:false,
            showResultEncuestas:false,
            loadingGetDataEncuestas: false,
            showDataEncuestas: false,
            columnsEncuestas: ['Fecha','Semana','Area','Agencia','Estado','Ciudad','Rol','Usuario','Canal','Cadena','Formato','Tienda','Trade','Pregunta','Respuesta','Comentario'],
            tableDataEncuestas: [],
            optionsEncuestas: {
                footerHeadings:false,
                filterByColumn:true,
                perPage:5,
                perPageValues: [5,10],
                filterable: ['Usuario','Tienda','Area','Formato','Canal','Cadena'],
                sortIcon:
                    { base:'fontawesome', up:'fas fa-long-arrow-alt-up', down:'fas fa-long-arrow-alt-down', is:'fas fa-sort' }
                ,
                listColumns: {
                },
                cellClasses:{
                },
                columnsDropdown:false,
                headings: {
                    Id: '#',
                    Fecha: 'Fecha Hora Registro',
                    Gestor: 'Usuario',
                },
                columnsClasses: {
                    Id: 'text-center font-bold text-danger',
                    Producto: 'text-center',
                    Gestor: 'text-center',
                    Tienda: 'text-center',
                    Area: 'text-center',
                    Formato: 'text-center',
                    Canal: 'text-center',
                    Cadena: 'text-center',
                    Fecha: 'text-center',
                    Comentario: 'text-justify',
                },
                texts: {
                    count: "Mostrando {from} al {to} de {count} registros|{count} registros|Un registro",
                    first: 'Primero',
                    last: 'Último',
                    filter: "Filtro:",
                    filterPlaceholder: "Buscar:",
                    limit: "Registros:",
                    page: "Pagína:",
                    noResults: "No hay resultados",
                    filterBy: "Filtrar",
                    loading: 'Buscando...',
                    defaultOption: 'Todos',
                    //defaultOption: 'Elige {column}',
                    columns: 'Columnas'
                },
            },
        }
    },
    mounted() {
    },
    methods:{
        keyboardEvent (e) {
            if (e.which === 13) {
                this.getReportEncuestas();
            }
        },
        getReportEncuestas(){ let $this = this;
            var filters = this.$refs.filtersReport.filters;
            if (filters.timeInit === null){
                this.$toastMessage('error',"Fecha Inicio Es Obligatoria",4000,'center');
            }else if (filters.timeEnd === null){
                this.$toastMessage('error',"Fecha Termino Es Obligatoria",4000,'center');
            }else{
                this.loadingGetDataEncuestas = true;
                this.showDataEncuestas = false;
                this.showResultEncuestas = false;
                this.tableDataInventario = [];
                axios.post('/api/Encuestas/Tabla',{data:filters})
                    .then(r => {
                            $this.loadingGetDataEncuestas = false;
                            $this.showDataEncuestas = true;
                            $this.tableDataEncuestas = r.data.Data;
                            $this.showResultEncuestas = true;
                        },
                        error => {
                            $this.$toastMessage('error','Error: ' + error +' Por favor envia este error al área de soporte!',9000,'center');
                        }
                    );
            }
        },
        ExportFileEncuestas(){let $this = this;
            this.loadfileEncuestas = true;
            var filters = this.$refs.filtersReport.filters;
            axios({
                method: 'post',
                url: '/api/Encuestas/exportLayoutToExcel',
                responseType: 'arraybuffer',
                data: {data: filters}}).then(r => {
                    let blob = new Blob([r.data], { type: 'application/xlsx' })
                    let link = document.createElement('a')
                    link.href = window.URL.createObjectURL(blob)
                    link.download = 'EncuestasMoet.xlsx'
                    link.click()
                    $this.loadfileEncuestas=false;
                },
                error => {
                    $this.$toastMessage('error','Error: ' + error +' Por favor envia este error al área de soporte!',9000,'center');
                    $this.loadfileEncuestas=false;
                }
            );
        },
    }
}
</script>

<style scoped>

</style>
